/**
 * Areiva — Product Actions: Share
 */
(function () {

  /* ── Share ── */
  function initShareBtn(btn) {
    if (!btn || btn._shareInit) return;
    btn._shareInit = true;

    var title    = btn.dataset.productTitle;
    var url      = btn.dataset.productUrl;
    var fullUrl  = window.location.origin + url;
    var label    = btn.querySelector('.product-action-btn__label');

    btn.addEventListener('click', function () {
      if (navigator.share) {
        navigator.share({ title: title, url: fullUrl }).catch(function () {});
      } else {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(fullUrl).then(function () {
            flashLabel(label, 'Link copied!');
          }).catch(function () { fallbackCopy(fullUrl, label); });
        } else {
          fallbackCopy(fullUrl, label);
        }
      }
    });
  }

  function flashLabel(label, msg) {
    if (!label) return;
    var orig = label.textContent;
    label.textContent = msg;
    setTimeout(function () { label.textContent = orig; }, 2200);
  }

  function fallbackCopy(text, label) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;opacity:0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand('copy'); flashLabel(label, 'Link copied!'); } catch (e) {}
    document.body.removeChild(ta);
  }

  /* ── Init ── */
  function init() {
    initShareBtn(document.getElementById('ShareBtn'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();